import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const { t } = useI18n();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "host" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) {
      toast.success("Hoşgeldiniz");
      navigate("/dashboard");
    } else toast.error(res.error);
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <Card className="p-8">
        <h1 className="font-serif text-3xl mb-1">{t.register}</h1>
        <p className="text-sm text-muted-foreground mb-6">{t.brand}</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>{t.name}</Label>
            <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="register-name" />
          </div>
          <div>
            <Label>{t.email}</Label>
            <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="register-email" />
          </div>
          <div>
            <Label>{t.password}</Label>
            <Input type="password" minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="register-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full h-11" data-testid="register-submit">
            {loading ? "..." : t.register}
          </Button>
        </form>
        <div className="mt-6 text-sm text-muted-foreground">
          <Link to="/login" className="text-primary underline underline-offset-4">{t.login}</Link>
        </div>
      </Card>
    </div>
  );
}
